module.exports = __webpack_public_path__ + "static/media/BTG.5498f20c.png";